<div class="modalContainer">
    <div class="modal-header">
        <div class="modal-title">Borrower Details</div>
        <div class="modal-sub-title">Below are the details of your invested loan.</div>
    </div>

    <div *ngIf="showLoader">
        <mat-spinner [diameter]="35" class="mat-spinner center-block"></mat-spinner>
    </div>

    <ng-container *ngIf="borrowerDetail && loan && !showLoader">
        <div class="modal-body">

            <div *ngIf="isShowLoanSuggestedTerm()" class="row background-approximate-snow mb-md-2">
                <div class="content-field font-weight-bold d-flex align-items-center">
                    <mat-label class="text-color-finzy-blue medium-big-text">Suggested Terms</mat-label>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">FINL</div>
                    <div class="content-value">{{loanSuggestedTerm?.generatedLoanId}}</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Name</div>
                    <div class="content-value">{{loanSuggestedTerm?.name}}</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Loan Amount</div>
                    <div class="content-value">{{loanSuggestedTerm?.loanAmount | currency:'INR': 'symbol': '2.2'}}</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Indicated Loan Rate</div>
                    <div class="content-value">{{loanSuggestedTerm?.roi | number : '2.2'}}% p.a.</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Indicated Tenure</div>
                    <div class="content-value">{{loanSuggestedTerm?.loanTenure}} m</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Suggested Interest Rate</div>
                    <div class="content-value">{{loanSuggestedTerm?.userSuggestedTerms[0]?.lenderSuggestedRate | number : '2.2'}}% p.a.</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Suggested Tenure</div>
                    <div class="content-value">{{loanSuggestedTerm?.userSuggestedTerms[0]?.lenderSuggestedTenure}} m</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Status</div>
                    <div class="content-value">{{loanSuggestedTerm?.userSuggestedTerms[0]?.lenderStatus}}</div>
                </div>

                <div class="content-field col-xs-12 mb-md-4 text-right">
                    <button type="button" mat-stroked-button class="outlined-btn" (click)="investmentNegotiationHandler()">
                        Modify
                    </button>

                    <button type="button" class="mat-flat-button stroke-btn mat-primary ml-md-3 mr-md-5 width-auto" (click)="investmentNegotiationWithdrawnHandler()">
                        Withdraw
                    </button>
                </div>
            </div>

            <div class="row">
                <div *ngIf="loanSuggestedTerm && loanSuggestedTerm?.userSuggestedTerms?.length" class="content-field font-weight-bold d-flex align-items-center">
                    <mat-label class="text-color-finzy-blue medium-big-text">Offered terms</mat-label>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Name</div>
                    <div class="content-value">{{borrowerDetail.name}}</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Gender</div>
                    <div class="content-value">{{borrowerDetail.gender}}</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Age</div>
                    <div class="content-value">{{borrowerDetail.age}}</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Loan Amount</div>
                    <div class="content-value">{{loan.loanAmount | currency:'INR': 'symbol': '2.2'}}</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Allocated Amount</div>
                    <div class="content-value">{{loan.investmentAmount | currency:'INR': 'symbol': '2.2'}}</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Tenure</div>
                    <div class="content-value">{{loan.tenure}} m</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Finzy Rating</div>
                    <div class="content-value">{{loan.finzyRating}}</div>
                </div>

                <div class="content-field col-lg-3 col-md-4 col-xs-6">
                    <div class="content-level">Loan Status</div>
                    <div class="content-value">{{populateLoanStatus()}}</div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" mat-flat-button class="outlined-btn" [mat-dialog-close]="true"
                cdkFocusInitial>Back</button>
            <button type="button" *ngIf="isShowSuggestedLoanTermButton()" class="mat-flat-button mat-primary ml-md-4 mr-md-5"
                style="width: auto;" (click)="investmentNegotiationHandler()">Negotiate Loan terms</button>
        </div>
    </ng-container>
</div>